import { readString } from "react-papaparse";
import { type ParseResult } from "papaparse";

/**
 * CSVファイルを読み込む
 * @param file CSVファイル
 * @return CSVパース結果オブジェクト
 */
export const readCSV = async (file: File): Promise<ParseResult<unknown>> =>
  await new Promise<ParseResult<string>>((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener("error", () => {
      reject(reader.error);
    });
    reader.addEventListener("load", () => {
      const { result } = reader;
      if (typeof result !== "string") {
        reject(reader.error);
      }
      readString<string>(result as string, {
        worker: true,
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          resolve(results);
        },
        error(error: Error) {
          reject(error);
        },
      });
    });
    reader.readAsText(file);
  });
